import React from 'react';

import { OfferCard } from '@/components/Shared/ui';
import { type TAutoCredLeasingResponse } from '@/types/newOrder';

interface LeasingOffersErrorProps {
  leasingOffer?: TAutoCredLeasingResponse;
}

const LeasingOffersError: React.FC<LeasingOffersErrorProps> = ({
  leasingOffer
}) => {
  return (
    <OfferCard className="bank-item" status="error" statusText="Ошибка">
      <OfferCard.Header title={leasingOffer?.leasingCompany.name || ''} />
    </OfferCard>
  );
};

export default LeasingOffersError;
